module.exports = __webpack_public_path__ + "img/سازمانی،اداری.a6b9f4fb.png";